export default __webpack_public_path__ + "static/media/vote_proxy_4.09a5e94b.jpg";